import { RouterProvider } from "react-router";
import { AuthProvider } from "app/presentation/contexts/auth/Provider";
import { BreakpointProvider } from "app/presentation/contexts/breakpoint/Provider";
import { LocaleProvider } from "app/presentation/contexts/locale/Provider";
import { SidebarProvider } from "app/presentation/contexts/sidebar/Provider";
import { ThemeProvider } from "app/presentation/contexts/theme/Provider";
import router from "app/router/router";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <LocaleProvider>
          <BreakpointProvider>
            <SidebarProvider>
              <RouterProvider router={router} />
            </SidebarProvider>
          </BreakpointProvider>
        </LocaleProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;